module.exports = __webpack_public_path__ + "img/AEDC.b2cbc0f9.svg";